import React from 'react'
import { BANK_INPUT_FIELDS, } from './banking-constant'

import { TbDevicesDollar, TbPencil } from 'react-icons/tb'
import CardBg from "../../../assets/image/card-bg.png"
import { Box, Button, Col, FabButton, Flex, Gap, InputField, Row, SelectField, Switchbox, Typography } from '../../../ppui'
import useCommonfn from '../../../utils/useCommonfn'
import { BankCard, BankCardBg, Card, CardHeading } from '../../style'

const OwnershipList = ({ resource, handleResetForm, setOpen, handleClickOpen, getInputFieldPropsFn, handleSubmitFn }) => {

  if (!resource) {
    throw new Promise(() => { })
  }
  const bankRes = resource.read();
  const {navigateToDashBoard}=useCommonfn()

  return (

    <>
   {/* {bankRes?.data?.data?.
          data?.length > 0 &&    
          <Flex justifyContent="space-between" gap={"10"}  mb={18}>
        <Typography variant="h5" mb={"0"}>
          Bank List
        </Typography>

        <Button
            color="primary"
            size="sm"
            variant="outlined"
            onClick={handleClickOpen}
          >
            Add New
          </Button>
      </Flex>
          } */}
      {
        bankRes?.data?.data?.
          data?.length > 0 ? <>
          <Card>
            <CardHeading Divider>
              Banking Information
              {/* <Button
                color="primary"
                size="sm"
                variant="outlined"
                onClick={handleClickOpen}
              >
                Add New
              </Button> */}
              <Button
                    onClick={handleClickOpen}
                    color="primary"
                    variant="contained"
                    size="sm"
                    icon={<TbDevicesDollar/>}
                  >
                Add New
              </Button>

            </CardHeading>
            <Row rowGap={20}>
            {bankRes?.data?.data?.data?.map((it, ind) => (
              <Col sm={12} md={6} xl={4} key={ind}>
                <BankCard>
                  <BankCardBg>
                    <img src={CardBg} alt="" />
                  </BankCardBg>
                  <Flex justifyContent="space-between">
                    <Box>
                      <Typography variant='h6' color="primary" mb={"0"}>{it?.bank_name}</Typography>
                      <Typography variant='body2' sx={{ fontSize: "0.75rem" }} mb={"0"} color="primary">{it?.branch_name}</Typography>
                    </Box>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbPencil />}
                        color='primary'
                        onClick={() => {
                          handleResetForm(it)
                          setOpen(true);
                        }}
                        variant="icon"
                        shape=""
                      />
                    </Box>
                  </Flex>
                  <Box mt={"40"}>
                      <Typography variant='body2' sx={{ fontSize: "0.75rem" }} mb={"0"} color="primary">Account Number</Typography>
                      <Typography variant='h5' color="primary">{it?.account_no}</Typography>
                      <Typography variant='body2' color="primary" mb={"0"}>IFSC No: {it?.ifsc_no}</Typography>
                  </Box>
                </BankCard>
              </Col>
            ))}
            </Row>
          </Card>

        </> : <>
          <Typography variant="h5">
            Bank Account
          </Typography>
          <Row rowGap>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BANK_INPUT_FIELDS.bank_name.name)}
              />
            </Col>

            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BANK_INPUT_FIELDS.branch_name.name)}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BANK_INPUT_FIELDS.account_no.name)}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BANK_INPUT_FIELDS.ifsc_no.name)}
              />
            </Col>

            <Col sm={6}>
              <SelectField
                placeholder="Select Here..."
                {...getInputFieldPropsFn(BANK_INPUT_FIELDS.account_type.name)}
              />
            </Col>

            <Col sm={6}>
              <Switchbox
                {...getInputFieldPropsFn(BANK_INPUT_FIELDS.is_primary.name)}
              />
            </Col>
          </Row>
          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={navigateToDashBoard} variant="outlined">
              Cancel
            </Button>

            <Button color="primary" onClick={handleSubmitFn} variant="contained">
              Submit
            </Button>
          </Flex> </>
      }


    </>

  )
}

export default OwnershipList